import React from 'react'
import { Box, Card, CardContent, Chip, Typography } from '@mui/material'
import { AnimatedSection } from '../../components/animations/MotionContainers'

export const UserTasks = () => (
  <Box className="page-fade">
    <Box className="page-heading suite-page-heading-row">
      <Box>
        <Typography variant="h4">Tareas pendientes</Typography>
        <Typography>Revisa los trabajos asignados y su prioridad operativa.</Typography>
      </Box>
      <Chip className="suite-status-chip" label="0 pendientes" />
    </Box>

    <AnimatedSection><Card className="reminder-card suite-view-card">
      <CardContent>
        <Typography className="section-title">Listado de tareas</Typography>
        <Box className="suite-detail-list">
          <Typography className="admin-user-empty">
            No hay tareas pendientes asignadas desde Clasol Suite.
          </Typography>
        </Box>
      </CardContent>
    </Card></AnimatedSection>
  </Box>
)
